import {
  WITHDRAWAL_LIST,
  WITHDRAWAL_LIST_SUCCESS,
  WITHDRAWAL_LIST_FAILURE,
} from "../actionTypes";

export const withdrawalList = (payload) => ({
  type: WITHDRAWAL_LIST,
  payload,
});

export const withdrawalListSuccess = (payload) => ({
  type: WITHDRAWAL_LIST_SUCCESS,
  payload,
});

export const withdrawalListFailure = () => ({
  type: WITHDRAWAL_LIST_FAILURE,
});
